import { Loader } from 'components/Core'

import { useJoorPayUseReachFlag } from '../Review/review.queries'
import PublicInvoice from './PublicInvoice'
import { useAnonymousOrder } from './PublicInvoice.queries'

const PublicInvoiceContainer = () => {
  const anonymousOrderData = useAnonymousOrder()
  const { loading: featureFlagJoorPayQueryLoading, data } =
    useJoorPayUseReachFlag(anonymousOrderData?.order?.brand?.id)

  if (featureFlagJoorPayQueryLoading) {
    return <Loader active />
  }
  if (data?.public.useJoorPay) {
    return <PublicInvoice {...anonymousOrderData} />
  }

  return null
}

export default PublicInvoiceContainer
